import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import Dashboard from './Dashboard';

import en from '../i18n/en';

i18next.addResourceBundle('en', 'dashboard', en);

const DashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Home',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.HOME,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/home',
      component: Dashboard,
      when: 'always',
      cacheKey: 'cache-dashboard',
    },
  ],
};

export default DashboardConfig;
